
export class BrandStyles {
  constructor (
    public kioskBody: Object = {},
    public kioskButton: Object = {},
    public appHeader: Object = {},
    public appButton: Object = {}
  ) {}
}

export const BrandStylesDefault = new BrandStyles();

export interface BrandingData {
  id?: Number | string,
  css?: string | null,
  entity?: BaseEntityProps,
  logoUrl?: string,
  logo?: string,
  name?: string,
  kioskBackground?: string,
  kioskBackgroundUrl?: string,
  kioskLogo?: string,
  kioskLogoUrl?: string,
  introduction?: string,
  terms?: string,
  entryDeniedMessage?: string
}

export default class Branding {
  constructor (branding: BrandingData) {
    Object.assign(this, branding || {})
  }
}